import cn from 'classnames';
import { useTranslation } from 'next-i18next';

import { PromoBadge as PromoBadgeProps } from '@adapters/bigcommerce/types/product';

import { HitVariant } from '@components/algolia/Hit';

import styles from './PromoBadge.module.scss';

const PromoBadge = ({
  promotion,
  placement = 'pdp',
  salePrice = 0,
}: {
  promotion: PromoBadgeProps | Exclude<HitVariant['badge'], undefined> | null;
  placement: 'pdp' | 'hit';
  salePrice?: number;
}) => {
  const translationFile = placement === 'pdp' ? 'pdp' : 'searchResults';
  const { t } = useTranslation(translationFile);
  if (!promotion) return null;

  if (placement === 'hit' && promotion.code !== 'NEW' && salePrice === 0)
    return null; // TODO can probably be removed once data is fixed

  const isMemberBadge = 'isMemberBadge' in promotion && promotion.isMemberBadge;

  const getBadgeText = () => {
    if (promotion.code === 'NEW') {
      return t('product.badge.new');
    }

    if (isMemberBadge) {
      const memberBadgeKeys: Record<string, string> = {
        SALE: 'product.badge.member.sale',
        CLEARANCE: 'product.badge.member.clearance',
      };

      if (memberBadgeKeys[promotion.code]) {
        return t(memberBadgeKeys[promotion.code]);
      }
    }

    const key = promotion.multi_discount
      ? 'product.badge.save.upto'
      : 'product.badge.save';

    return t(key, { percent: promotion.discount_percentage });
  };

  const text = getBadgeText();

  return (
    <div
      className={cn(styles.base, {
        [styles.pdp]: placement === 'pdp',
        [styles.hit]: placement === 'hit',
        [styles[promotion.code.toLowerCase()]]: promotion.code,
      })}
    >
      {text}
    </div>
  );
};

export default PromoBadge;
